export const phraseBook: Record<string, string> = {
  "how much does it cost": "¿cuánto cuesta?",
  "how much is it": "¿cuánto es?",
  "where is the market": "¿dónde está el mercado?",
  "where is the train station": "¿dónde está la estación de tren?",
  "good morning": "buenos días",
  "good night": "buenas noches",
  "thank you very much": "muchas gracias",
  "i would like a coffee": "quisiera un café",
  "the bill please": "la cuenta, por favor",
  "see you tomorrow": "hasta mañana",
  "i dont understand": "no entiendo",
  "can you help me": "¿me puede ayudar?",
  "nice to meet you": "encantado de conocerte",
  "i am learning spanish": "estoy aprendiendo español",
};

export const wordBook: Record<string, string> = {
  the: "el",
  market: "mercado",
  apple: "manzana",
  cheese: "queso",
  bread: "pan",
  bag: "bolsa",
  fish: "pescado",
  water: "agua",
  coffee: "café",
  milk: "leche",
  egg: "huevo",
  tomato: "tomate",
  orange: "naranja",
  cheap: "barato",
  expensive: "caro",
  where: "dónde",
  is: "está",
  how: "cómo",
  much: "mucho",
  i: "yo",
  want: "quiero",
  a: "un",
  please: "por favor",
  thanks: "gracias",
  you: "tú",
  hello: "hola",
  goodbye: "adiós",
  friend: "amigo",
  house: "casa",
  street: "calle",
  station: "estación",
  train: "tren",
  ticket: "billete",
  today: "hoy",
  tomorrow: "mañana",
  good: "bueno",
  day: "día",
  big: "grande",
  small: "pequeño",
  red: "rojo",
  green: "verde",
  and: "y",
  with: "con",
  without: "sin",
  receipt: "recibo",
  tip: "propina",
  queue: "cola",
  strawberries: "fresas",
  avocado: "aguacate",
  kilo: "kilo",
  of: "de",
  buy: "comprar",
  eat: "comer",
  drink: "beber",
  book: "libro",
  word: "palabra",
  language: "idioma",
  beach: "playa",
  sun: "sol",
  love: "amor",
  cat: "gato",
  dog: "perro",
};
